package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.style.TextAlign
import one.healthium.ui.compose.components.AppTextField
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.uscreen.domain.models.KeyboardType
import one.healthium.uscreen.domain.models.TextCapitalization
import one.healthium.uscreen.domain.models.TextInputBlock
import one.healthium.uscreen.ui.UScreenAnswer
import one.healthium.uscreen.ui.animation.POST_TRANSITION_DELAY
import one.healthium.uscreen.ui.util.uscreenPadding
import kotlin.time.Duration.Companion.milliseconds
import androidx.compose.ui.text.input.KeyboardType as ComposeKeyboardType

@Composable
fun UScreenTextInputBlock(
    modifier: Modifier = Modifier,
    block: TextInputBlock,
    answers: Map<String, UScreenAnswer>,
    onTextChanged: (key: String, value: String) -> Unit,
    onSubmit: () -> Unit,
) {
    val initialValue = (answers[block.key] as? UScreenAnswer.TextAnswer)?.text.orEmpty()
    var localValue by remember(block.key) { mutableStateOf(initialValue) }

    AppTextField(
        value = localValue,
        onValueChange = {
            localValue = it
            onTextChanged(block.key, it.trim())
        },
        placeholder = null,
        textStyle = AppTheme.textStyles.textField.copy(textAlign = TextAlign.Center),
        keyboardOptions = KeyboardOptions(
            keyboardType = block.keyboard.toComposeKeyboardType(),
            capitalization = block.capitalization.toComposeCapitalization(),
            imeAction = ImeAction.Done,
        ),
        keyboardActions = KeyboardActions(onDone = { onSubmit() }),
        maxLines = 1,
        showKeyboardAutomatically = block.autoFocus && initialValue.isEmpty(),
        showKeyboardDelay = POST_TRANSITION_DELAY.milliseconds,
        modifier = modifier
            .fillMaxWidth()
            .uscreenPadding(block.padding)
            .testTag("uscreen_text_input"),
    )
}

private fun KeyboardType.toComposeKeyboardType(): ComposeKeyboardType = when (this) {
    KeyboardType.Text -> ComposeKeyboardType.Text
    KeyboardType.Default -> ComposeKeyboardType.Text
    KeyboardType.Number -> ComposeKeyboardType.Number
    KeyboardType.Email -> ComposeKeyboardType.Email
}

private fun TextCapitalization.toComposeCapitalization(): KeyboardCapitalization = when (this) {
    TextCapitalization.None -> KeyboardCapitalization.None
    TextCapitalization.Words -> KeyboardCapitalization.Words
    TextCapitalization.Sentences -> KeyboardCapitalization.Sentences
    TextCapitalization.Characters -> KeyboardCapitalization.Characters
}
